import globalStyles from "../../assets/styles/base/globalPage.module.scss";
import { Outlet } from "react-router-dom";

export const PerformanceLayout = () => {
  return (
    <div className={`${globalStyles?.pagePaddings}`}>
      <Outlet />
    </div>
  );
};
